/* eslint-disable */
import React from 'react';

export const Banner30DataSource = {
    wrapper: {className: 'TalentStrategy_banner3 k0qcuji2xa8-editor_css'},
    textWrapper: {
        className: 'TalentStrategy_banner3-text-wrapper k0qct9r6a-editor_css',
        children: [
            {
                name: 'nameEn',
                className: 'TalentStrategy_banner3-name-en k0qcth162j-editor_css',
                children: (
                    <>
                        <p style={{color:"#fff"}}>Talent strategy</p>
                    </>
                ),
            },
            {
                name: 'slogan',
                className: 'TalentStrategy_banner3-slogan k0qcsufjqz-editor_css',
                children: '人才战略',
                texty: true,
            },

        ],
    },
};
export const Feature30DataSource = {
    wrapper: {className: 'home-page-wrapper content3-wrapper'},
    page: {className: 'home-page content3'},
    OverPack: {playScale: 0.3},
    titleWrapper: {
        className: 'title-wrapper',
        children: [
            {
                name: 'title',
                children: (
                    <>
                        <p>职位信息/Position Information</p>
                    </>
                ),
                className: 'title-h1',
            },
        ],
    },
    block: {
        className: 'content3-block-wrapper',
        children: [
            {
                name: 'block0',
                className: 'content3-block',
                md: 6,
                xs: 24,
                children: {
                    // icon: {
                    //     className: 'content3-icon',
                    //     children:
                    //         'https://zos.alipayobjects.com/rmsportal/ScHBSdwpTkAHZkJ.png',
                    // },
                    textWrapper: {className: 'content3-text'},
                    title: {
                        className: 'content3-title',
                        children: (
                            <>
                                <p className="fontColor" >气象模型工程师</p>
                            </>
                        ),
                    },
                    content: {
                        className: 'content3-content k0qdsz1b5ts-editor_css',
                        children: (
                            <>
                                <p>企业：南京雨后地软环境技术有限公司</p>
                                <p>工作地点：&nbsp;江苏南京</p>
                                <p>发布日期：2019-09-18&nbsp;</p>
                            </>
                        ),
                    },
                },
            },
            {
                name: 'block1',
                className: 'content3-block',
                md: 6,
                xs: 24,
                children: {
                    // icon: {
                    //     className: 'content3-icon',
                    //     children:
                    //         'https://zos.alipayobjects.com/rmsportal/NKBELAOuuKbofDD.png',
                    // },
                    textWrapper: {className: 'content3-text'},
                    title: {
                        className: 'content3-title',
                        children: (
                            <>
                                <p className="fontColor"  > 环境工程师（源解析）</p>
                            </>
                        ),
                    },
                    content: {
                        className: 'content3-content k0qdt2u02uj-editor_css',
                        children: (
                            <>
                                <p>企业：南京雨后地软环境技术有限公司</p>
                                <p>工作地点： 江苏南京</p>
                                <p>发布日期：2019-09-18&nbsp;</p>
                            </>
                        ),
                    },
                },
            },
            {
                name: 'block2',
                className: 'content3-block',
                md: 6,
                xs: 24,
                children: {
                    // icon: {
                    //     className: 'content3-icon',
                    //     children:
                    //         'https://zos.alipayobjects.com/rmsportal/xMSBjgxBhKfyMWX.png',
                    // },
                    textWrapper: {className: 'content3-text'},
                    title: {
                        className: 'content3-title',
                        children: (
                            <>
                                <p className="fontColor" >生态系统工程师</p>
                            </>
                        ),
                    },
                    content: {
                        className: 'content3-content k0qdt5qhy5-editor_css',
                        children: (
                            <>
                                <p>企业：南京雨后地软环境技术有限公司</p>
                                <p>工作地点： 江苏南京</p>
                                <p>发布日期：2019-09-18&nbsp;</p>
                            </>
                        ),
                    },
                },
            },
            {
                name: 'block3',
                className: 'content3-block',
                md: 6,
                xs: 24,
                children: {
                    // icon: {
                    //     className: 'content3-icon',
                    //     children:
                    //         'https://zos.alipayobjects.com/rmsportal/MNdlBNhmDBLuzqp.png',
                    // },
                    textWrapper: {className: 'content3-text'},
                    title: {
                        className: 'content3-title',
                        children: (
                            <>
                                <p className="fontColor" >可视化工程师</p>
                            </>
                        ),
                    },
                    content: {
                        className: 'content3-content k0qdt7qf24-editor_css',
                        children: (
                            <>
                                <p>企业：南京雨后地软环境技术有限公司</p>
                                <p>工作地点： 江苏南京</p>
                                <p>发布日期：2019-09-18&nbsp;</p>
                            </>
                        ),
                    },
                },
            },
        ],
    },
};
export const Feature10DataSource = {
    wrapper: {className: 'home-page-wrapper content1-wrapper'},
    OverPack: {className: 'home-page content1', playScale: 0.3},
    imgWrapper: {className: 'content1-img', md: 10, xs: 24},
    img: {
        // children: 'https://zos.alipayobjects.com/rmsportal/nLzbeGQLPyBJoli.png',
        children: 'img/talents3.png',

    },
    textWrapper: {className: 'content1-text', md: 14, xs: 24},
    title: {
        className: 'content1-title',
        children: (
            <>
                <p> </p>
            </>
        ),
    },
    content: {
        className: 'content1-content',
        children: (
            <>
                <p style={{margin:"10% 0",lineHeight:"30px"}}>不拘一格引进、培养行业卓越人才，在公司各业务领域均有学科带头人并形成人才梯队。建立“人尽其才，才尽其用，德才兼备”的用人机制，
                    建立一支具备核心竞争力、文化凝聚力的人才队伍。将人才视为公司最宝贵的财富，践行“以奋斗者为本”的战略思想，坚持绩效导向的分配原则，
                    所有回报与激励将毫不动摇的向做出突出贡献的员工倾斜。不断深化员工激励体系，保持薪酬竞争力，为员工提供施展才能的机会，
                    搭建实现人生理想和事业追求的舞台，使公司价值及员工价值得到充分体现。&nbsp;</p>
            </>
        ),
    },
};

export const PositionList = [
    {
        title: "气象模型工程师",
        feTitle: "所属公司：南京雨后地软环境技术有限公司",
        position: "江苏南京",
        responsibility: ["1、负责中尺度数值天气预报模式（如WRF）的运营维护、物理过程优化和模拟预报及评估分析工作；",
            "2、负责相关气象资料的获取和同化分析技术；",
            "3、负责研发提高数值天气预报精度和准确性的相关技术工作，能够与业主方进行必要的业务沟通工作；",
            "4、负责有关中尺度数值预报工作的技术指导；",
            "5、完成职位相关的其他工作。"],
            // 任职要求
        require: ["1、气象学、大气科学相关专业硕士及以上学历；",
            "2、具备大气科学、大气动力学、数值天气预报等的基础知识与原理，熟悉资料同化技术；",
            "3、掌握主流中尺度数值天气预报模式(如WRF,ARPS等)的安装调试和运行模拟，对模式的物理过程有比较深入的理解；",
            "4、具有数值预报模式开发、模式应用、数据同化等相关经验，有相关项目经验者优先；",
            "5、有良好的团队意识、沟通能力、学习能力和执行能力。"],
    },
    {
        title: "空气质量模型工程师 ",
        feTitle: "所属公司：南京雨后地软环境技术有限公司",
        position: "江苏南京",
        responsibility: ["1、负责大气污染物的监测、评估和数据挖掘等工作；",
            "2、负责对大气污染颗粒物及化学成分的源解析及源清单分析，对天然VOCs排放的监测和估算相关工作；",
            "3、负责源解析、源清单模型的开发及应用，参与大气污染与空气质量影响的数值耦合模拟工作；",
            "4、负责大气污染相关工程的方案设计及技术工作，能够与业主方进行必要的业务沟通工作；",
            "5、负责大气污染工程现场的技术指导；",
            "6、完成职位相关的其他工作。"
        ],//职责
        require: ["1、大气污染学、大气物理学、大气化学等相关专业硕士及以上学历；",
            "2、掌握大气污染的基础知识与原理，熟悉大气污染物监测仪器的工作原理、大气污染物源解析、源清单及VOCs监测与估算的相关原理方法；",
            "3、从事过源解析、源排放及VOCs估算模型的开发及应用工作，对主流的源解析模型（CMB、PMF等）及源排放模型（SMOKE等）有比较深入的了解和应用；",
            "4、有源清单编制及源解析项目经验者优先考虑；",
            "5、有良好的团队意识、沟通能力、学习能力和执行能力。",
        ],//要求
    },
    {
        title: "生态系统工程师",
        feTitle: "所属公司：南京雨后地软环境技术有限公司",
        position: "江苏南京",
        responsibility:
            ["1、负责生态环境监测与评估、生态遥感反演、生态恢复等工作；",
                "2、负责生态系统数值模型的开发及应用，参与生态与气候系统数值模拟工作；",
                "3、负责生态环境工程的方案设计及技术工作，能够与业主方进行必要的业务沟通工作；",
                "4、负责生态环境工程现场的技术指导；",
                "5、完成职位相关的其他工作。",
            ]
        ,//职责
        require:
            ["1、生态学、环境学等相关专业硕士及以上学历；",
                "2、掌握基础生态学知识与原理，熟悉草原植被生态、湿地生态及土壤生态学，能够独立编制相关工程建设方案；",
                "3、从事过生态系统数值模型的建模与模拟分析、生态与气候变化影响模拟工作；",
                "4、有良好的团队意识、沟通能力、学习能力和执行能力。",
            ]
        ,//要求
    },
    {
        title: "可视化工程师",
        feTitle: "所属公司：南京雨后地软环境技术有限公司",
        position: "江苏南京",
        responsibility:
            ["1、根据公司项目需求搭建WebGIS可视化开发框架与平台；",
                "2、基于遥感影像，对气象、环境等要素进行2D和3D以及动态可视化；",
                "3、根据需要，基于Windows或Linux系统，开发WebGIS平台可视化系统，设计并实现空间分析等相关算法；",
                "4、对环境或气象要素进行GIS可视化，搭建系统可视化平台；",
                "5、完成职位相关的其他工作。",
            ]
        ,//职责
        require:
            ["1、计算机、地理信息系统、大气科学等相关专业硕士及以上学历；",
                "2、熟悉C++、Python、Java、IDL等语言，至少精通其中一种用于前端可视化开发；",
                "3、熟悉Linux、Windows及安卓系统，具有较好的可视化编程能力，尤其是基于WebGIS的可视化编程能力；",
                "4、了解数据库技术和熟悉GIS技术，能够将气象、环境等要素以等值线、等值面、风矢、流场等多形式进行多种2D投影及3D地球GIS平台可视化，能够对流场图进行动态可视化，对云进行3D虚拟可视化。",
                "5、有气象数据可视化开发项目经验者优先。",
            ]
        ,//要求
    },
];










